import { Reveal } from '@/components/ui/Reveal'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { SitePhoto } from '@/components/ui/SitePhoto'
import { kandakeOutdoors } from '@/assets/siteMedia'

const stats = [
  { value: '10,000+', label: 'Individuals worked with' },
  { value: '15+', label: 'Years of herb walks' },
  { value: '30+', label: 'Herbal formulas' },
]

export const AboutStory = () => (
  <section className="bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <div className="mx-auto w-full max-w-md overflow-hidden rounded-3xl border border-base-200 bg-white p-2 shadow-[0_16px_48px_rgba(26,70,26,0.07)] sm:p-3 lg:max-w-none">
            <SitePhoto
              src={kandakeOutdoors}
              alt="Kandake Makonnen in her herbal practice"
              aspect="aspect-[4/5]"
              className="rounded-2xl"
            />
          </div>
        </Reveal>

        <div>
          <SectionHeader
            title="About Kandake"
            accent="Makonnen"
            description="Medical & Traditional Herbalist | Holistic Consultant | Herbal Formulator · Founder of Instrumental Health"
            className="mb-8"
          />
          <Reveal>
            <div className="space-y-5 text-base leading-7 text-base-600">
              <p>
                Kandake's relationship with plant medicine began in Jamaica, where her grandmother
                introduced her to traditional herbal remedies passed down through generations. She
                later spent 15 years living within the Rastafari community, deepening her connection
                to nature, traditional healing and collective wellbeing.
              </p>
              <p>
                She graduated from the University of Westminster in 2008 with a BSc (Hons) in
                Medical Herbalism and subsequently worked alongside medical professionals at a
                GP-led holistic health centre in North London.
              </p>
              <p>
                Founder of Instrumental Health in 2004, Kandake brings over 30 years of holistic
                health experience and a conservative estimate of 10,000+ hours of direct clinical
                practice. Her work has reached over 10,000 people through consultations, health
                programmes and education. Drawing on this experience, she has developed and refined
                more than 30 original herbal formulations shaped by traditional knowledge, clinical
                observation and client needs.
              </p>
              <p>
                Her studies with traditional healers in Gambia, Togo and Burkina Faso further inform
                her practice. As the Official UK Representative of the Dogon Kemetic School, she has
                shared these traditions internationally, including teaching in Canada and Spain and
                speaking at Medicine Festival in the UK.
              </p>
              <p>
                A committed educator and community advocate, Kandake has worked extensively with
                schools, women's groups and community organisations, including five years with the
                Workers' Educational Association (WEA). During COVID-19, she responded to requests
                from members of the community by developing herbal preparations and organising a
                series of online webinars bringing together health practitioners, wealth and
                business professionals, and spiritual healers. These conversations subsequently
                inspired the award-winning documentary <em>I See You</em>, which she co-created and
                co-produced.
              </p>
              <p>
                Recipient of Haringey Borough's Unsung Women's Award, she is currently developing{' '}
                <em>The Cycle of Womanhood</em>, a three-volume series exploring women's health from
                menarche through menopause and beyond.
              </p>
              <p className="border-l-2 border-gold-300 pl-4 font-display text-lg leading-snug text-base-900">
                Healing begins when we learn to listen, not only to the body, but to the whole
                person.
              </p>
            </div>
          </Reveal>

          <Reveal>
            <dl className="mt-8 grid grid-cols-3 gap-4 rounded-2xl border border-green-100 bg-green-50 p-5 text-center sm:p-6">
              {stats.map((s) => (
                <div key={s.label} className="flex flex-col items-center">
                  <dd className="order-1 font-display text-3xl leading-none text-green-800 sm:text-4xl">
                    {s.value}
                  </dd>
                  <dt className="order-2 mt-2 text-xs leading-snug text-green-800 sm:text-sm">
                    {s.label}
                  </dt>
                </div>
              ))}
            </dl>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
)
